function closeMtoModal(e, modalMessage, modalOverlay) {
  e.preventDefault();
  modalMessage.classList.add("none");
  modalMessage.classList.remove("active");
  modalOverlay.classList.add("hidden");
}

const mtoModalMessage = document.querySelector(".mto-modal-message");

if (mtoModalMessage !== null) {
  const mtoModalTriggers = document.querySelectorAll(".mto-modal-trigger");
  const mtoModalOverlay = document.querySelector(".mto-modal-overlay");
  const mtoModalClose = document.querySelector(".mto-modal-close");
  const mtoModalCloseImg = document.querySelector(".mto-modal-close img");

  mtoModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === mtoModalClose ||
        e.target === mtoModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      mtoModalMessage.classList.remove("none");
      mtoModalMessage.classList.add("active");
      mtoModalOverlay.classList.remove("hidden");
    });
  });

  mtoModalClose.addEventListener("click", (e) => {
    closeMtoModal(e, mtoModalMessage, mtoModalOverlay);
  });

  mtoModalOverlay.addEventListener("click", (e) => {
    closeMtoModal(e, mtoModalMessage, mtoModalOverlay);
  });
}
